export default __webpack_public_path__ + "static/media/Antos.df08b9e0.jpg";